import { orderBy } from 'lodash';

export function sortApplications(applications) {
  return orderBy(
    applications,
    [
      'invitedToMoveInDateTime',
      (application) => orderBy(application.applicants, ['submittedDateTime'], ['desc'])[0].submittedDateTime,
      'declinedDateTime',
      'withdrawnDateTime',
    ],
    ['desc', 'desc', 'desc', 'desc'],
  );
}
